import React from 'react'
import { Modal } from 'antd-mobile'
import { Container, Wrapper, Header } from '../../../components_renew/Layout'
import CardGameBlock from './CardGameBlock'
import CardGameCarousel from './CardGameCarousel'
import CardGameBGImg from '../../../assets/xiniu/card_game/card-game-bg.png'
import CardGameInfoImg from '../../../assets/xiniu/card_game/card-game-info.png'
import CardGamePrizeImg from '../../../assets/xiniu/card_game/card-game-prize.png'
import { postMessage } from '../../../utils'
import classnames from 'classnames'

class RuleButton extends React.PureComponent {
  render () {
    return <div>
      <div className={'card-game__rule'} onClick={this.onClick}>活动规则</div>
    </div>
  }

  onClick = () => {
    Modal.alert({
      title: '活动规则',
      content: <div>
        1. 活动有效期：见图有效；<br/>
        2. 活动对象：所有注册用户均可参与；<br/>
        3.
        参与方式：1个自然日内，每现金订购1件指定订金的商品即获1次翻牌机会，每个自然日最高可获得10次翻牌机会（活动有效期内天天可参与）；<br/>
        4. 翻牌机会仅获取当日零点前有效，逾期未使用视为放弃；<br/>
        5. 奖品内容随机发放，券(积分)值请以实际翻牌中获得为准，中奖率100%：<br/>
        【订购商城】3-300元订购券，用于订购商城预订商品时抵扣订金（券值随机）<br/>
        {/*【零售商城】50-500元零售券，用于零售商城购买任意商品时候抵扣现金（券值随机）<br />*/}
        【积分商城】80-3888商城积分，用于积分商城任意积分活动（积分值随机）<br/>
        6.订购券、零售券自获得日起7天有效，逾期未使用视为放弃；<br/>
        7. 发放时间：一经翻牌，即刻到账！可至『我的』-『我的卡券』或『积分商城』查看；<br/>
        8. 如需帮助请在线留言，平台将第一时间为您服务（服务时间：周一至周五 9:00-12:00 14:00-17:30 ）<br/>
        9. 应用内一切抽奖活动与苹果公司及相关应用市场无关，最终解释权归本APP所有。<br/>
      </div>
    }).then()
  }

}

class CardGame extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = Boolean(urlParams.get('withHeader'))
  }

  componentDidMount () {
    document.title = '幸运翻翻翻'
  }

  render () {
    return <Container className={'card-game__container'}>
      {/*<Wrapper className={'card-game__wrapper'}>*/}
      <Wrapper transparent
               className={classnames('card-game__wrapper', { 'card-game__wrapper--header': this.withHeader })}>
        {/*<img className={'card-game__bg'} src={CardGameBGImg} alt="" />*/}
        {/*幽灵头部，默认不显示，如需要则url里传参数withHeader=true*/}
        <Header ghost/>
        <RuleButton/>
        <div className={'card-game__content'}>
          <img className={'card-game__bg'} src={CardGameBGImg} alt=""/>
          <div className={'card-game__info'}><img src={CardGameInfoImg} onClick={this.onInfoClick} alt=""/></div>
          <CardGameBlock/>
          <div className={'card-game__prize'}><img src={CardGamePrizeImg} alt=""/></div>
        </div>
        <CardGameCarousel/>
        <br/>
        <br/>
        {/*<div className={'card-game__bottom'}>*/}
        {/*  —— 更多活动 敬请期待 ——*/}
        {/*</div>*/}
      </Wrapper>
    </Container>
  }

  onInfoClick = () => {
    postMessage({ type: window.POST_TYPE.BUY })
  }
}

export default CardGame
